<template>
  <div class="card">
    <Toast />

    <div class="title">Daftar Bon Toko</div>

    <div class="table-container">
      <DataTable
        :value="items"
        :paginator="true"
        :lazy="true"
        class="p-datatable-sm"
        :rows="10"
        data-key="doc_number"
        :totalRecords="totalItem"
        :loading="loading1"
        @page="onPage($event)"
      >
        <template #header>
          <div class="p-grid p-fluid">
            <!-- Filter Inputs Row -->
            <div class="p-col-12 p-md-4">
              <label for="outlet" class="block mb-1">Toko</label>
              <AutoComplete
                id="outlet"
                v-model="selectedOutlet"
                :suggestions="autoFilteredValue"
                field="name"
                @complete="searchOutlets($event)"
                :dropdown="true"
                placeholder="Cari toko..."
                class="w-100"
              >
                <template #item="slotProps">
                  <div class="outlet-item">
                    <span class="outlet-text"
                      >{{ slotProps.item.code }} -
                      {{ slotProps.item.name }}</span
                    >
                  </div>
                </template>
              </AutoComplete>
            </div>

            <div class="p-col-12 p-md-4">
              <label for="doc-date" class="block mb-1">Tanggal Bon</label>
              <Calendar
                id="doc-date"
                v-model="filter.doc_date"
                :showIcon="true"
                dateFormat="dd/mm/yy"
                @date-select="isError.doc_date = false"
                class="w-100"
              />
              <small class="p-error" v-if="isError.doc_date">{{
                error_msg.doc_date
              }}</small>
            </div>

            <div class="p-col-12 p-md-4">
              <label for="doc-number" class="block mb-1">Nomor Bon</label>
              <InputText
                id="doc-number"
                type="text"
                v-model="filter.doc_number"
                placeholder="Cari nomor bon..."
                @keyup.prevent="isError.doc_number = false"
                class="w-100"
              />
              <small class="p-error" v-if="isError.doc_number">{{
                error_msg.doc_number
              }}</small>
            </div>

            <!-- Filter Buttons Row -->
            <div class="p-col-12 p-md-3 p-lg-3 p-d-flex p-ai-end">
              <Button
                label="Cari"
                icon="pi pi-search"
                @click="saveFilters()"
                :loading="loadingFilter.filterButton"
                class="p-mr-2"
              />
              <Button
                label="Reset"
                icon="pi pi-refresh"
                @click="resetFilters()"
                class="p-button-secondary"
                v-tooltip.top="'Reset Filter'"
              />
            </div>
          </div>
        </template>

        <template #empty>
          <div class="empty-state">
            <i class="pi pi-inbox mb-3" style="font-size: 2rem"></i>
            <p>Data tidak tersedia</p>
          </div>
        </template>

        <Column field="no" header="No." :style="{ width: '5%' }">
          <template #body="slotProps">
            {{ (slotProps.data.index || 0) + 1 }}
          </template>
        </Column>

        <Column field="outlet_name" header="Toko">
          <template #body="slotProps">
            <span class="text-truncate">
              <span class="font-medium">{{ slotProps.data.outlet_code }}</span>
              <span class="mx-2"> - </span>
              <span>{{ slotProps.data.outlet_name }}</span>
            </span>
          </template>
        </Column>

        <Column field="doc_date" header="Tanggal Bon">
          <template #body="slotProps">
            <span>{{ slotProps.data.doc_date }}</span>
          </template>
        </Column>

        <Column field="doc_number" header="No Bon">
          <template #body="slotProps">
            <span class="font-medium">{{ slotProps.data.doc_number }}</span>
          </template>
        </Column>

        <Column field="total_item" header="Total Barang">
          <template #body="slotProps">
            {{ slotProps.data.total_item }}
          </template>
        </Column>

        <Column field="total_price" header="Total Harga">
          <template #body="slotProps">
            <span class="font-medium">{{
              slotProps.data.total_price | currency
            }}</span>
          </template>
        </Column>

        <Column header="Aksi" :style="{ width: '120px', minWidth: '120px' }">
          <template #body="slotProps">
            <div class="action-buttons">
              <Button
                icon="pi pi-print"
                @click="printBon(slotProps.data.doc_number)"
                class="p-button-rounded p-mx-1"
                v-tooltip.top="'Cetak Bon'"
              />
              <Button
                icon="pi pi-file"
                @click="exportBon(slotProps.data.doc_number)"
                class="p-button-rounded p-mx-1"
                v-tooltip.top="'Export CSV'"
              />
              <router-link
                :to="{
                  name: 'bon-detail',
                  query: { doc_number: slotProps.data.doc_number }
                }"
              >
                <Button
                  icon="pi pi-eye"
                  class="p-button-success p-button-rounded"
                  v-tooltip.top="'Lihat Detail'"
                />
              </router-link>
            </div>
          </template>
        </Column>
      </DataTable>
    </div>

    <Dialog
      :visible.sync="deleteDialog"
      :style="{ width: '450px' }"
      header="Konfirmasi Hapus"
      :modal="true"
      class="p-fluid"
    >
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
        <span v-if="outletInbound">
          Apakah Anda yakin ingin menghapus bon
          <b>{{ outletInbound.doc_number }}</b
          >?
        </span>
      </div>
      <template #footer>
        <Button
          label="Batal"
          icon="pi pi-times"
          class="p-button-text"
          @click="deleteDialog = false"
        />
        <Button
          label="Ya"
          icon="pi pi-check"
          class="p-button-text"
          @click="deleteOutletInbound(outletInbound.doc_number)"
          :loading="loading.deleteButton"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
let moment = require('moment')
export default {
  data() {
    return {
      moment: moment,
      selectedOutlets: null,
      selectedOutlet: { id: '', code: '', name: '' },
      autoFilteredValue: [],
      filter: {
        doc_number: '',
        doc_date: '',
        outlet: ''
      },
      defaultFilter: {
        doc_number: '',
        doc_date: '',
        outlet: ''
      },
      totalItem: 0,
      totalPage: 1,
      loading1: true,
      expandedRows: [],
      items: null,
      deleteDialog: false,
      outletInbound: {},
      loading: {
        deleteButton: false
      },
      error_msg: {
        doc_number: '',
        doc_date: '',
        outlet: [{ id: '', name: '' }]
      },
      loadingFilter: {
        filterButton: false
      },
      isError: {
        doc_number: false,
        doc_date: false,
        outlet: [{ id: false, name: false }]
      },
      detail: null
    }
  },

  mounted() {
    this.getListDistribution()
    this.getListOutlets()
  },

  methods: {
    searchOutlets(event) {
      this.autoFilteredValue = this.selectedOutlets.filter(item => {
        return (
          item.code.toLowerCase().includes(event.query.toLowerCase()) ||
          item.name.toLowerCase().includes(event.query.toLowerCase())
        )
      })
    },

    getListOutlets() {
      return new Promise((resolve, reject) => {
        this.$http
          .get(`${process.env.VUE_APP_API_URL}/outlets`)
          .then(response => {
            if (response.status === 200) {
              resolve((this.selectedOutlets = response.data.data.outlets))
            } else {
              reject(new Error('Failed to fetch data'))
              console.error('gagal get')
            }
          })
          .catch(error => {
            console.error(error)
            reject(error)
          })
      })
    },

    saveFilters() {
      this.loadingFilter.filterButton = true
      this.getListDistribution().finally(() => {
        this.loadingFilter.filterButton = false
      })
    },

    getListDistribution(event) {
      let out_id = this.selectedOutlet.id ? this.selectedOutlet.id : ''
      let offset = 0
      if (event) {
        offset = event.first
      }
      this.items = []
      this.loading1 = true

      return new Promise((resolve, reject) => {
        this.$http
          .get(
            `${process.env.VUE_APP_API_URL}/dashboard/outlet-inbounds?doc_number=${this.filter.doc_number}&doc_date=${this.filter.doc_date}&outlet_id=${out_id}&limit=10&offset=${offset}&order_by=-doc_date,-doc_number`
          )
          .then(response => {
            if (response.status === 200) {
              resolve('Success get data')
              this.items = response.data.data.outlet_inbounds.map(
                (item, index) => ({
                  ...item,
                  index: offset + index
                })
              )
              this.totalItem = Number(response.data.data.total_item)
            } else {
              console.error('Failed to fetch data')
              reject(new Error('Failed to fetch data'))
            }
          })
          .catch(error => {
            console.error(error)
            reject(error)
          })
          .finally(() => {
            this.loading1 = false
          })
      })
    },

    confirmDelete(outletInbound) {
      this.outletInbound = outletInbound
      this.deleteDialog = true
    },

    deleteOutletInbound(doc_number) {
      this.loading.deleteButton = true
      return new Promise((resolve, reject) => {
        this.$http
          .delete(
            `${process.env.VUE_APP_API_URL}/dashboard/outlet_inbounds?doc_number=${doc_number}`
          )
          .then(response => {
            this.loading.deleteButton = false
            this.deleteDialog = false
            if (response.status === 200) {
              resolve(this.getListOutlets())
            } else {
              this.$toast.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Gagal Menghapus Data'
              })
              console.error('gagal delete')
              reject(new Error('Failed to delete data'))
            }
          })
          .catch(error => {
            this.$toast.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Gagal Menghapus Data'
            })
            console.error(error)
            reject(error)
          })
      })
    },

    printBon(doc_number) {
      return new Promise((resolve, reject) => {
        this.$http
          .get(
            `${process.env.VUE_APP_API_URL}/dashboard/outlet-inbound?doc_number=${doc_number}`
          )
          .then(response => {
            if (response.status === 200) {
              resolve(
                (this.detail = response.data.data),
                this.$router.push({
                  name: 'print-receiving',
                  params: { detail: this.detail }
                })
              )
            } else {
              this.$toast.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Gagal mengambil data'
              })
              console.error(response.data)
              reject(new Error('Failed to fetch data'))
            }
          })
          .catch(error => {
            this.$toast.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Gagal mengambil data'
            })
            console.error(error)
            reject(error)
          })
      })
    },

    exportBon(doc_number) {
      return new Promise((resolve, reject) => {
        this.$http
          .get(
            `${process.env.VUE_APP_API_URL}/dashboard/outlet-inbounds/csv?doc_number=${doc_number}`,
            { responseType: 'blob' }
          )
          .then(response => {
            if (response.status === 200) {
              let blob = new Blob([response.data], {
                type: response.headers['content-type']
              })
              let link = document.createElement('a')
              link.href = window.URL.createObjectURL(blob)
              link.download = `BONRECEIVING_${doc_number}.csv`
              link.click()
              resolve('Export Success')
            } else {
              this.$toast.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Failed to export CSV'
              })
              console.error(response.data)
              reject(new Error('Failed to export CSV'))
            }
          })
          .catch(error => {
            this.$toast.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Failed to export CSV'
            })
            console.error(error)
            reject(error)
          })
      })
    },

    resetFilters() {
      this.selectedOutlet = { id: '', code: '', name: '' }
      this.filter = { ...this.defaultFilter }
      this.getListDistribution()
    },

    onPage(event) {
      this.getListDistribution(event)
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  background: #ffffff;
  border-radius: 6px;
  box-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14),
    0 1px 3px 0 rgba(0, 0, 0, 0.12);
  padding: 1.5rem;

  .title {
    font-size: 1.5rem;
    font-weight: 600;
    color: #495057;
    margin-bottom: 1.5rem;
  }
}

.outlet-item {
  padding: 0.5rem;

  .outlet-text {
    font-size: 0.875rem;
    color: #495057;
  }
}

.w-100 {
  width: 100%;
}

.empty-state,
.loading-overlay {
  text-align: center;
  padding: 2rem;
  color: #6c757d;

  i {
    color: #2196f3;
  }
}

.text-truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  display: inline-block;
}

.text-right {
  text-align: right;
}

.font-medium {
  font-weight: 500;
}

.w-full {
  width: 100%;
}

.action-buttons {
  display: flex;
  justify-content: center;
  gap: 0.5rem;
  min-width: 120px;
  white-space: nowrap;
}

:deep(.p-datatable) {
  position: relative;
  width: 100%;

  .p-datatable-thead > tr > th {
    background-color: #f8f9fa;
    padding: 0.75rem;
    font-size: 0.875rem;
    font-weight: 600;
    color: #495057;
    position: sticky;
    top: 0;
    z-index: 0;
    text-align: center;
    border-bottom: 2px solid #dee2e6;

    &:nth-child(1) {
      width: 5%;
      min-width: 50px;
    }
    &:nth-child(2) {
      width: 20%;
      min-width: 200px;
    }
    &:nth-child(3) {
      width: 15%;
      min-width: 120px;
    }
    &:nth-child(4) {
      width: 20%;
      min-width: 150px;
    }
    &:nth-child(5) {
      width: 10%;
      min-width: 100px;
    }
    &:nth-child(6) {
      width: 15%;
      min-width: 120px;
    }
    &:nth-child(7) {
      width: 15%;
      min-width: 120px;
    }
  }

  .p-datatable-tbody > tr > td {
    padding: 0.75rem;
    font-size: 0.875rem;
    background: #ffffff;
    border-bottom: 1px solid #dee2e6;

    &:nth-child(1),
    &:nth-child(3),
    &:nth-child(4) {
      text-align: center;
    }

    &:nth-child(2) {
      text-align: left;
    }

    &:nth-child(5),
    &:nth-child(6) {
      text-align: right;
    }

    &:nth-child(1) {
      width: 5%;
      min-width: 50px;
    }
    &:nth-child(2) {
      width: 20%;
      min-width: 200px;
    }
    &:nth-child(3) {
      width: 15%;
      min-width: 120px;
    }
    &:nth-child(4) {
      width: 20%;
      min-width: 150px;
    }
    &:nth-child(5) {
      width: 10%;
      min-width: 100px;
    }
    &:nth-child(6) {
      width: 15%;
      min-width: 120px;
    }
    &:nth-child(7) {
      width: 15%;
      min-width: 120px;
    }
  }

  .p-datatable-tbody > tr:hover {
    background-color: rgba(0, 0, 0, 0.02);
  }

  .p-datatable-tbody > tr.p-highlight {
    background-color: #e3f2fd;
    color: #1976d2;

    .font-medium {
      color: #1976d2;
    }

    .text-truncate {
      color: #1976d2;
    }

    .text-right {
      color: #1976d2;
    }
  }
}

.confirmation-content {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;

  i {
    color: #f44336;
    margin-right: 1rem;
  }
}
</style>
